<template>
  <section id="tac-admin-sales-refund" class="tac-admin-sales-refund tac-admin-sales-refund__list">
    <div class="page-header">
      <h1 class="page-header-title">
        <router-link :to="{name: 'admin/sales-refund/list'}" class="page-header__title-link--no-highlight">
          <span class="fa fa-fw fa-th"></span> Sales Refund
        </router-link>
        <small>List</small>
      </h1>
      <div class="page-header-actions page-header-actions--right-position">
        <div class="form-inline form-inline--better-spaced form-inline--compact form-inline--one-liner">
          <div class="form-group form-group-sm">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData || isFormClear()" @click="search">Search</button>
              </div>
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" :disabled="fetchingData || isFormClear()" @click="clear">Clear</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group form-group-sm">
            <div class="btn-toolbar">
              <div class="btn-group">
                <router-link :to="linkToNewRecord()" class="btn btn-default btn-sm" :disabled="fetchingData">New</router-link>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-inline__divider"></div>
          </div>
          <div class="form-group">
            <div class="btn-toolbar">
              <div class="btn-group">
                <button type="button" class="btn btn-default btn-sm" @click="reload" title="Refresh Page" :disabled="fetchingData"><i class="fa fa-fw fa-refresh"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <form class="form" @submit.prevent="search">
      <div class="row">
        <div class="col-lg-3">
          <div class="form-horizontal">
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-2">Number</label>
              <div class="col-lg-10">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.number" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-2">Amount</label>
              <div class="col-lg-10">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.amount" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-2">BN</label>
              <div class="col-lg-10">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.batchNumber" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="form-horizontal">
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-3">Company</label>
              <div class="col-lg-9">
                <input :disabled="fetchingData || true" type="text" class="form-control" v-model="form.company" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-3">Last Name</label>
              <div class="col-lg-9">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.lastName" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-3">First Name</label>
              <div class="col-lg-9">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.firstName" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="form-horizontal">
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-2">Telephone</label>
              <div class="col-lg-10">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.telephone" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-2">Email</label>
              <div class="col-lg-10">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.email" />
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-2">
          <div class="form-horizontal">
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-2">ZIP</label>
              <div class="col-lg-10">
                <input :disabled="fetchingData || true" type="text" class="form-control" v-model="form.zip" />
              </div>
            </div>
            <div class="form-group form-group-sm">
              <label class="control-label col-lg-2">Date</label>
              <div class="col-lg-10">
                <input :disabled="fetchingData" type="text" class="form-control" v-model="form.date" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <button type="submit" class="sr-only">Submit</button>
    </form>
    <div class="row">
      <div class="col-lg-9">
        <div class="panel panel-default">
          <table class="table table-bordered table-striped table-hover table-condensed">
            <thead>
              <tr>
                <th class="col-lg-1 text-center">ID</th>
                <th class="col-lg-4">Customer</th>
                <th class="col-lg-2">Method</th>
                <th class="col-lg-1 text-right">Amount</th>
                <th class="col-lg-1 text-center">Date</th>
                <th class="col-lg-1 text-center">CM #</th>
                <th class="col-lg-1 text-center">Status</th>
                <th class="col-lg-1 text-center" title="Batch Number">BN</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!refunds.length">
                <td class="text-center text-warning" colspan="8">
                  No refund found.  Try a different search parameter.
                </td>
              </tr>
              <tr v-for="(refund, key) in refunds" :key="key">
                <td class="text-center">
                  <router-link :to="linkToRecord(refund)">{{ refund.refundNumber }}</router-link>
                </td>
                <td>{{ refund.customer.name }}</td>
                <td>{{ method(refund) }}</td>
                <td class="text-right"><money :value="refund.amount"></money></td>
                <td class="text-center">{{ refund.transactionDate | format('MM/DD/YYYY') }}</td>
                <td class="text-center">
                  <router-link :to="`/admin/credit_memo.php?cmID=${refund.creditMemoNumber}&action=view`" :disabled="fetchingData" target="_blank">
                    {{ refund.creditMemoNumber }}
                  </router-link>
                </td>
                <td class="text-center">{{ state(refund) }}</td>
                <td class="text-center">{{ refund.batchNumber }}</td>
              </tr>
            </tbody>
            <tfoot v-if="!!refunds.length">
              <tr>
                <td colspan="8">
                  <pagination
                    class="text-center pagination-compact"
                    :p-total="pagination.total"
                    :p-per-page="pagination.perPage"
                    :p-page="pagination.page"
                    @open-page="openPage"
                    >
                  </pagination>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="panel panel-default">
          <div class="panel-heading">
            Filter
          </div>
          <div class="panel-body">
            <div class="form">
              <div class="form-horizontal">
                <div class="form-group form-group-sm">
                  <label class="control-label col-lg-4">Method</label>
                  <div class="col-lg-8">
                    <select :disabled="fetchingData" class="form-control" v-model="filter.method" @change="search">
                      <option></option>
                      <optgroup label="Credit Card">
                        <option value="cc"               >All</option>
                        <option value="visa"             >Visa</option>
                        <option value="master-card"      >Master Card</option>
                        <option value="american-express" >American Express</option>
                        <option value="discover"         >Discover</option>
                        <option value="vmd"              >V/M/D</option>
                      </optgroup>
                      <option value="accountcredit">Account Credit</option>
                      <option value="wirexfr"      >Wire Transfer</option>
                      <option value="paypal"       >PayPal</option>
                      <option value="faxcheck"     >Fax Check</option>
                      <option value="moneyorder"   >Check / Money Order</option>
                      <option value="cash"         >Cash</option>
                    </select>
                  </div>
                </div>
                <div class="form-group form-group-sm">
                  <label class="control-label col-lg-4">Status</label>
                  <div class="col-lg-8">
                    <select :disabled="fetchingData" class="form-control" v-model="filter.status" @change="search">
                      <option></option>
                      <option value="pending" >Pending</option>
                      <option value="declined">Declined</option>
                      <option value="active"  >Active</option>
                      <option value="void"    >Void</option>
                      <option value="deleted" >Deleted</option>
                    </select>
                  </div>
                </div>
                <div class="form-group form-group-sm">
                  <label class="control-label col-lg-4">Deposited</label>
                  <div class="col-lg-8">
                    <select :disabled="fetchingData || true" class="form-control" v-model="filter.deposited" @change="search">
                      <option></option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                </div>
                <div class="form-group form-group-sm">
                  <label class="control-label col-lg-4">No Batch Number</label>
                  <div class="col-lg-8">
                    <select :disabled="fetchingData" class="form-control" v-model="filter.noBatchNumber" @change="search">
                      <option></option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div><!-- .panel -->
      </div><!-- .col-* -->
    </div><!-- .row -->
  </section>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex'
import { format } from '@/plugin/filter/date'
import Pagination from '@/plugin/bootstrap/pagination';
import ApiResponseMixin from '@/plugin/mixin/api-response'
import Money from '@/plugin/element/money'
import MoneyMixin from '@/plugin/mixin/money'

const FORM_MODEL = {
  number      : null,
  amount      : null,
  batchNumber : null,
  company     : null,
  firstName   : null,
  lastName    : null,
  telephone   : null,
  email       : null,
  zip         : null,
  date        : null,
}

const FILTER_MODEL = {
  method        : null,
  status        : null,
  deposited     : null,
  noBatchNumber : null
}

export default {
  name: 'list',
  data() {
    return {
      form   : FORM_MODEL,
      filter : FILTER_MODEL
    }
  },
  created() {
    this.$alertify.dismissAll()

    this.loadFromRoute()
    this.fetchData()
  },
  watch: {
    $route() {
      this.loadFromRoute()
      this.fetchData()
    }
  },
  computed: {
    ...mapState('salesRefund/refunds', {
      refunds: 'items',
      pagination: 'pagination',
      fetchingData: 'requested',
    })
  },
  methods: {
    reload() {
      this.fetchData()
    },
    fetchData() {
      this.$store.dispatch(
        'salesRefund/refunds/updateFilter',
        this.compileFilters()
      )
      this.$store.dispatch('salesRefund/refunds/fetch')
    },
    openPage(page) {
      if (!_.isNumber(page)) {
        return
      }
      this.$store.dispatch('salesRefund/refunds/changePage', page)
    },
    openRecord(refund) {
      const refundNumber = _.get(refund, 'refundNumber')
      if (!_.isNumber(refundNumber)) {
        return
      }
      this.$router.push({
        name   : 'admin/sales-refund/record',
        params : Object.assign({}, this.$route.params, {refundNumber: refundNumber}),
        query  : Object.assign({}, this.$route.query),
      })
    },
    linkToRecord(refund) {
      const params = Object.assign({}, this.$route.params, {
        action       : 'view',
        refundNumber : refund.refundNumber,
      })
      return {
        name   : 'admin/sales-refund/record',
        params : params,
        query  : Object.assign({}, this.$route.query),
      }
    },
    linkToNewRecord() {
      return {
        name  : 'admin/sales-refund/new-request',
        query : Object.assign({}, this.$route.query),
      }
    },
    search() {
      if (this.fetchingData) {
        return
      }

      let query = this.createSearchQuery()

      this.$router.push({
        name   : 'admin/sales-refund/list',
        params : Object.assign({}, this.$route.params),
        query  : query,
      })
    },
    clear() {
      if (this.fetchingData) {
        return
      }

      this.form = Object.assign({}, FORM_MODEL)

      let query = this.createSearchQuery()

      this.$router.push({
        name   : 'admin/sales-refund/list',
        params : Object.assign({}, this.$route.params),
        query  : query,
      })
    },
    createSearchQuery() {
      let query = _.chain({})
        .assign(this.$route.query)
        .omit(_.keys(FORM_MODEL))
        .omit(_.keys(FILTER_MODEL))
        .value()

      if (!this.isFormClear()) {
        const form = _.pickBy(this.form, (field) => {
          return !_.isEmpty(field)
        })
        query = Object.assign({}, query, form)
      }
      if (!this.isFilterClear()) {
        const filter = _.pickBy(this.filter, (field) => {
          return !_.isEmpty(field)
        })
        query = Object.assign({}, query, filter)
      }

      return query
    },
    compileFilters() {
      let filters = {}

      if (!this.isFormClear()) {
        const form = _.pickBy(this.form, (field) => {
          return !_.isEmpty(field)
        })
        filters = _.assign({}, filters, form)
      }
      if (!this.isFilterClear()) {
        const filter = _.pickBy(this.filter, (field) => {
          return !_.isEmpty(field)
        })
        filters = _.assign({}, filters, filter)
      }

      return filters
    },
    isFormClear() {
      return _.isEmpty(_.get(this.form, 'number'))
        && _.isEmpty(_.get(this.form, 'amount'))
        && _.isEmpty(_.get(this.form, 'batchNumber'))
        && _.isEmpty(_.get(this.form, 'company'))
        && _.isEmpty(_.get(this.form, 'firstName'))
        && _.isEmpty(_.get(this.form, 'lastName'))
        && _.isEmpty(_.get(this.form, 'telephone'))
        && _.isEmpty(_.get(this.form, 'email'))
        && _.isEmpty(_.get(this.form, 'zip'))
        && _.isEmpty(_.get(this.form, 'date'))
    },
    isFilterClear() {
      return _.isEmpty(_.get(this.filter, 'method'))
        && _.isEmpty(_.get(this.filter, 'status'))
        && _.isEmpty(_.get(this.filter, 'deposited'))
        && _.isEmpty(_.get(this.filter, 'noBatchNumber'))
    },
    method(refund) {
      if ('cc' === refund.type.code) {
        return refund.type.brand
      }

      switch (refund.type.code) {
        case 'accountcredit':
          return 'Account Credit'
        case 'cash':
          return 'Cash'
        case 'creditcard':
          return 'Credit Card'
        case 'faxcheck':
          return 'Fax Check'
        case 'moneyorder':
          return 'Check / Money Order'
        case 'paypal':
          return 'PayPal'
        case 'wirexfr':
          return 'Wire Transfer'
      }

      return 'Unknown'
    },
    state(refund) {
      return _.upperFirst(refund.state)
    },
    loadFromRoute() {
      this.form   = _.pick(_.get(this.$route, 'query', {}), _.keys(FORM_MODEL))
      this.filter = _.pick(_.get(this.$route, 'query', {}), _.keys(FILTER_MODEL))
    }
  },
  components: {
    Money,
    Pagination
  },
  filters: {
    format
  },
  mixins: [
    ApiResponseMixin,
    MoneyMixin
  ]
}
</script>

<style lang="scss" scoped>
.page-header {
  position: relative;

  .page-header-actions {
    &--right-position {
      position: absolute;
      right: 15px;
      top: -8px;

      .form-group--tree-select {
        width: 200px;
      }
    }
  }
}
</style>
